var _circle, _circle2, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 335.71,
    cy: 335.71,
    r: 22.14
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 176.28,
    cy: 176.28,
    r: 22.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M345.17,234.86h-19a73.26,73.26,0,1,0-91.29,91.28v19a21.14,21.14,0,1,0,42.28,0v-19a73.58,73.58,0,0,0,49-49h19a21.14,21.14,0,1,0,0-42.28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M335.21,145.88a21.14,21.14,0,1,0-29.89,29.89l30.9,30.91a21.14,21.14,0,1,0,29.9-29.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M143.26,213a21.13,21.13,0,0,0-21.13,21.13v43.71a21.14,21.14,0,1,0,42.27,0V234.14A21.13,21.13,0,0,0,143.26,213Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M256,0C114.84,0,0,114.84,0,256S114.84,512,256,512,512,397.16,512,256,397.16,0,256,0Zm0,429.33c-95.57,0-173.33-77.75-173.33-173.33S160.43,82.67,256,82.67,429.33,160.43,429.33,256,351.58,429.33,256,429.33Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCell);
export default __webpack_public_path__ + "static/media/cell.8d84574c1dd6f18b3ea33339b8be5eb7.svg";
export { ForwardRef as ReactComponent };